import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";

const URL_API = ApiUrl.BASE;

const PuntosService = {

  async insertar(puntos) {
    const respuesta = await ApiService(URL_API).post("/admin/comunicaciones-cultura/puntos", puntos);
    return respuesta.data;
  },

  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/puntos", { params });
    return respuesta.data;
  },

  async exportar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/puntos/exportar", {
      params: { ...params },
      responseType: "blob",
    });
    return respuesta;
  },
};

export { PuntosService };
